import React, { useState, useEffect } from 'react';
import { useRouteData, useSiteData, Head } from 'react-static';
import Session from '@nmx/utils-frontend/dist/utilities/frontend/session';
// template components
import ContentHub from '@nmx/template/dist/componentLibrary/modules/ContentHub';
import Page from '@nmx/template/dist/componentLibrary/layout/Page';
// native components
import AdvisorConnectModule from './components/advisorConnectModule';
import AdvisorMatchChecklist from './components/advisorMatchChecklist';
import FafaPoll from './components/fafaPoll';
import FirstAdvisorMeeting from './components/firstAdvisorMeeting';
import FRSearchDirectory from './components/frSearchDirectory';
import FRSearchDirectoryVariant from './components/frSearchDirectoryVariant';
import GetMatchedBanner from './components/getMatchedBanner';
import GetMatchedBannerExperienceA from './components/getMatchedBannerExperienceA';
import GetMatchedBannerExperienceB from './components/getMatchedBannerExperienceB';
import InPageLeadFormSection from './components/inPageLeadFormSection';
import NumberedNextSteps from './components/numberedNextSteps';
// utils
import getAdobeTargetExperience from '../../utils/getAdobeTargetExperience';
import { getImmediateMatchFeatureFlag } from '../../utils/getFeatureFlags/getFeatureFlags';

export default () => {
  const { config, dynamicConfig } = useSiteData();
  const { pageProps, contentHubItems } = useRouteData();
  const [adobeTargetExperienceName, setAdobeTargetExperienceName] = useState(false);
  const [hideContentForUnder40kUsers, setHideContentForUnder40kUsers] = useState(Session.get('inPageLeadFormNoMatch'));
  const [immediateMatchFeatureFlag, setImmediateMatchFeatureFlag] = useState(false);

  const handleStorageChange = () => {
    setHideContentForUnder40kUsers(Session.get('inPageLeadFormNoMatch'));
  };

  let counter = 0;

  // on form submit, keep pinging session storage to see if the inPageLeadFormNoMatch updates to true
  const handleClick = () => {
    counter += 1;
    setTimeout(() => {
      handleStorageChange();
      const currentSessionValue = Session.get('inPageLeadFormNoMatch');
      if(currentSessionValue === 'false' && counter < 120){
        handleClick();
      }
    }, 250);
  };

  useEffect(() => {
    // gather adobe target experiment data
    getAdobeTargetExperience(config.public.fafaAdobeTargetActivityId).then((response) => {
      setAdobeTargetExperienceName(response);
    });
    // add click handler for fafa submit button
    const submitButton = document.getElementById('in-page-lead-step-submit-button');
    if (typeof document !== 'undefined' && submitButton) {
      submitButton.addEventListener('click', handleClick);
    }
    getImmediateMatchFeatureFlag(setImmediateMatchFeatureFlag, config);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Page
      {...pageProps} // defined in route.js
      headComponent={Head}
      config={config}
      dynamicConfig={dynamicConfig}
      useReCaptcha
      showGooglePlaces
      disableDisclaimerTopBorder>

      {/* experience A */}
      {adobeTargetExperienceName === config.public.fafaAdobeTargetExperienceNameA && (
        <>
          <GetMatchedBannerExperienceA />

          <AdvisorConnectModule />

          <ContentHub
            sectionId='fafa-page-helpful-reads-section'
            backgroundVariant='lightA'
            headingText='Helpful reads on partnering with an advisor'
            contentHubItems={contentHubItems} // defined in route.js
            config={config}
            disableLazyLoad
          />

          <FRSearchDirectoryVariant />
        </>
      )}

      {/* experience B */}
      {adobeTargetExperienceName === config.public.fafaAdobeTargetExperienceNameB && (
        <>
          <GetMatchedBannerExperienceB />

          <ContentHub
            sectionId='fafa-page-helpful-reads-section'
            backgroundVariant='lightA'
            headingText='Helpful reads on partnering with an advisor'
            contentHubItems={contentHubItems} // defined in route.js
            config={config}
            disableLazyLoad
          />

          <FRSearchDirectoryVariant />
        </>
      )}

      {/* default control */}
      {((adobeTargetExperienceName !== config.public.fafaAdobeTargetExperienceNameA) && (adobeTargetExperienceName !== config.public.fafaAdobeTargetExperienceNameB)) && (
        <>
          {(hideContentForUnder40kUsers !== 'true') && (
            <GetMatchedBanner />
          )}

          <InPageLeadFormSection immediateMatchFeatureFlagEnabled={immediateMatchFeatureFlag} />

          {/* Hide the following content if users are under $40K income and net worth */}
          {(hideContentForUnder40kUsers !== 'true') && (
            <>
              <AdvisorMatchChecklist />

              <FRSearchDirectory />

              <AdvisorConnectModule />

              <ContentHub
                backgroundVariant='lightA'
                config={config}
                contentHubItems={contentHubItems} // defined in route.js
                disableBottomPadding
                disableLazyLoad
                headingText='Helpful reads on partnering with an advisor'
                sectionId='fafa-page-helpful-reads-section'
              />

              <NumberedNextSteps />

              <FirstAdvisorMeeting />

              <FafaPoll />
            </>
          )}
        </>
      )}
    </Page>
  );
};
